import CopilotModule from './copilot-module';

export default CopilotModule;
